import PopUp from 'Components/PopUp';
import React, { useState } from 'react'
import { Button, Col, Container, Navbar, Row } from 'reactstrap'
import Layout from 'HorizontalMenu/Menu';
import { Link } from 'react-router-dom';
import ImportUserTable from './ImportUserTable';
import ImportUserSummary from './ImportUserSummary';

const ImportUsers = () => {
    const [importSumerized, setImportSumerized] = useState(false);

    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <Row className='pb-2 mb-2'>
                        <Col sm={2} className="d-flex align-items-center">
                            <Link className="btn_size_cstm mr-1 btn btn-primary" to="/users">
                                <i className="bx bx-chevron-left me-1" /> Back
                            </Link>
                        </Col>
                        <Col lg={9} className="d-flex align-items-center">
                            <h2 className="page_title pos-center text-uppercase mb-0">
                                Import Users
                            </h2>
                        </Col>
                    </Row>
                    <ImportUserTable />
                    <div className='d-flex flex-wrap gap-5 grp_justify_right'>
                        <Button color='primary' onClick={() => { setImportSumerized(true) }}>Import</Button>
                    </div>
                    {importSumerized &&
                        <PopUp
                            state={importSumerized}
                            setState={setImportSumerized}
                            body={<ImportUserSummary />}
                            title="Imported Users"
                            size="md"
                        />
                    }
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ImportUsers